export enum EPPriceFilterType {
  MIN_PRICE = "MIN_PRICE",
  MAX_PRICE = "MAX_PRICE"
}
